import { PieChart, Pie, Cell, Sector, ResponsiveContainer } from 'recharts';

const colors = [
  "#66c2a5",
  "#fc8d62",
  "#8da0cb",
  "#e78ac3",
  "#a6d854",
  "#ffd92f",
  "#e5c494",
  "#b3b3b3",
];

const renderActiveShape = (props) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
  
  return <Sector
    cx={cx}
    cy={cy}
    isAnimationActive
    startAngle={startAngle}
    endAngle={endAngle}
    innerRadius={innerRadius - 5}
    outerRadius={outerRadius + 10}
    fill={fill}
  />
}

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  // if(percent < 0.01) return;
  const radius = (outerRadius + innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fontSize={percent < 0.04 ? "0.7rem" : "1rem"} fill="white" textAnchor="middle" dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

function NeedsChart({items, isLoading, activeIndex, onSelect}) {

  if(isLoading) return "";

  const onPieEnter = (_, index) => {
    onSelect(index);
  }

  return (
    <>
      <ResponsiveContainer width="100%" height={600}>
        <PieChart onMouseLeave={() => {onSelect(null)}}>
          <Pie
            dataKey="amount"
            isAnimationActive={false}
            data={items}
            innerRadius={100}
            outerRadius={200}
            cx="50%"
            cy="50%"
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            onMouseEnter={onPieEnter}
            label={renderCustomizedLabel}
            labelLine={false}
          >
            {items.map((_, index) => (
              <Cell key={`cell-${index}`} fill={colors[index%8]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </>

  )
};

export default NeedsChart;